import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { getCreateABundleUrl } from 'pricing-pages-lib/utils/urls';
import { useHistory } from 'react-router-dom';
import { CRM_SUITE_PROFESSIONAL_BUNDLE } from 'self-service-api/constants/ApiNames';
import { FREE, PROFESSIONAL } from 'self-service-api/constants/ProductLevels';
import styled from 'styled-components';
import { PRODUCT_PAGE_HEADER } from '../../constants/tracking/Locations';
import { useAppSelector } from '../../reducers';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { isUngatedForPreSeatsFakePublicPortalSelector } from '../../selectors/GatingSelectors';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { productsAndPacksForQueryParamsSelector } from '../../selectors/ProductConfigsSelectors';
import { highestProductLevelFromProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import { productSelector } from '../../selectors/ProductsSelectors';
import { getClickedLinkEvent } from '../../utils/event-tracking/interactions';
import { trackEvent } from '../../utils/event-tracking/track-event';
import { jsx as _jsx } from "react/jsx-runtime";
const NoWrapLink = styled(UILink).withConfig({
  displayName: "CalculatorAnchorLink__NoWrapLink",
  componentId: "sc-14s1h33-0"
})(["white-space:nowrap;"]);
const CalculatorAnchorLink = ({
  productLine
}) => {
  const history = useHistory();
  const isAuthApp = useAppSelector(isAppAuthSelector);
  const isPreSeatsFakePublicPortal = useAppSelector(state => isUngatedForPreSeatsFakePublicPortalSelector(state));
  const hasPricingAndPurchasingSucceeded = useAppSelector(hasPricingAndPurchasingSucceededSelector);

  // get the highest owned level so we can create the query params with matching level
  const highestOwnedLevel = useAppSelector(state => hasPricingAndPurchasingSucceeded ? highestProductLevelFromProductInventorySelector(state) : null);

  // get the product so we can create the query params with skuId
  // default to professional if no paid product is found (sales people prefer we default to Pro)
  // default to suite professional bundle if no product line is provided
  const product = useAppSelector(state => {
    if (!hasPricingAndPurchasingSucceeded) return null;
    if (!productLine && highestOwnedLevel === FREE) {
      return productSelector(state, {
        apiName: CRM_SUITE_PROFESSIONAL_BUNDLE
      });
    }
    return productLine ? productSelector(state, {
      productLine,
      productLevel: highestOwnedLevel && highestOwnedLevel !== FREE ? highestOwnedLevel : PROFESSIONAL
    }) : null;
  });

  // create query params object from product configurations if product exists
  const queryParams = useAppSelector(state => product ? productsAndPacksForQueryParamsSelector(state, {
    productConfigurations: [createProductConfig({
      skuId: product.currentSkuId,
      quantity: 1
    })]
  }) : null);
  const handleClick = () => {
    const url = getCreateABundleUrl(isAuthApp && !isPreSeatsFakePublicPortal, queryParams);
    trackEvent(getClickedLinkEvent({
      type: 'internal',
      url,
      location: PRODUCT_PAGE_HEADER,
      value: I18n.text('pricingPage.pages.calculateYourPrice', {
        locale: 'en-us'
      })
    }));
    history.push(url);
  };
  return /*#__PURE__*/_jsx(NoWrapLink, {
    className: "m-left-2",
    onClick: handleClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pages.calculateYourPrice"
    })
  });
};
export default CalculatorAnchorLink;